import WidgetCard from "components/widgets/WidgetCard";
import { noop } from "lodash";
import React, {
  ReactNode,
  createContext,
  forwardRef,
  useContext,
  useMemo,
  useState,
} from "react";

interface WidgetCardContextType {
  isCustomWidgetTable: boolean;
  contentContainerStyle?: React.CSSProperties;
  setIsCustomWidgetTable: (value: boolean) => void;
  setContentContainerStyle: (value: React.CSSProperties) => void;
}
const WidgetContext = createContext<WidgetCardContextType>({
  isCustomWidgetTable: false,
  setIsCustomWidgetTable: () => {},
  setContentContainerStyle: noop,
});
interface WidgetProviderProps {
  children: ReactNode | ReactNode[];
}

export const WidgetCardProvider = forwardRef<any, WidgetProviderProps>(
  function WidgetCardProvider({ children, ...props }, ref) {
    const [isCustomWidgetTable, setIsCustomWidgetTable] = useState(false);
    const [contentContainerStyle, setContentContainerStyle] =
      useState<React.CSSProperties>();

    const value = useMemo<WidgetCardContextType>(
      () => ({
        isCustomWidgetTable,
        setIsCustomWidgetTable,
        contentContainerStyle,
        setContentContainerStyle,
      }),
      [isCustomWidgetTable, contentContainerStyle],
    );

    return (
      <WidgetContext.Provider value={value}>
        {
          //@ts-ignore
          <WidgetCard ref={ref} {...props}>
            {children}
          </WidgetCard>
        }
      </WidgetContext.Provider>
    );
  },
);

export function useWidgetCardSettingContext() {
  return useContext(WidgetContext);
}
